<div class="container review-section pb-3 pb-lg-5">
    <p class="review-header">REVIEWS</p>
    <!-- col-2: average rating -->
    <div class="avg-rating text-start col-12 d-block d-lg-none pt-2 pt-md-3">
        <span class="big mb-1">Average rating
            <small>{{ totalAverageOutOf5 | starpipe:'totalRating' }} of 5</small>
        </span>
        <div class="stars">
            <ng-container *ngIf="(totalAverageOutOf5 | starpipe:'fullStar') > 0;">
                <ng-container *ngFor="let fullstar of (totalAverageOutOf5 | starpipe:'fullStar': true)">
                    <i class="fa fa-star full-star" aria-hidden="true"></i>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="(totalAverageOutOf5 | starpipe:'halfStar') > 0">
                <ng-container *ngFor="let halfstar of (totalAverageOutOf5 | starpipe:'halfStar': true )">
                    <i class="fa fa-star-half-alt half-star" aria-hidden="true"></i>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="(totalAverageOutOf5 | starpipe:'noStar') > 0">
                <ng-container *ngFor="let noStar of (totalAverageOutOf5 | starpipe:'noStar': true)">
                    <i class="fa fa-star no-star" aria-hidden="true"></i>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div class="text-end d-none d-lg-block">
        <button class="btn btn-review mb-4" (click)="openReviewItPopup()">REVIEW PRODUCT</button>
    </div>
    <!-- Product Summary -->
    <div class="product-box d-flex flex-column flex-lg-row row pb-4">
        <!-- col-3: image -->
        <div class="product-img-col  mb-3 mb-lg-0 col-3 d-none d-lg-block"
            *ngIf="imageObject?.length > 0 else noImageRef">
            <div class="swiper product-img">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let img of imageObject">
                        <img [src]="img.image" [alt]="productName" class="slide-img" (error)="onImageError($event)"/>
                    </div>
                </div>
                <!-- <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div> -->
            </div>
        </div>
        <ng-template #noImageRef class="product-img-col me-lg-3 mb-3 mb-lg-0 col-2 d-none d-lg-block">
            <img [src]="commonImagePath+ 'image_not_found.webp'" alt="product" class="product-img lazyload"
                loading="lazy">
        </ng-template>
        <!-- col-7: title + rating bars -->
        <div class="product-details flex-grow-1 me-lg-3 col-12 col-md-6">
            <h3 class="product-title pb-4" *ngIf="!!productName" [title]="productName">
                <strong>{{productName}}</strong>
            </h3>
            <div class="rating-bars mt-3">
                <div class="d-flex align-items-center mb-2">
                    <div class="rating-label">Appearance</div>
                    <div class="progress flex-grow-1">
                        <div class="progress-bar appearance" role="progressbar" aria-valuenow="90" aria-valuemin="0"
                            aria-valuemax="100"
                            [style.width.%]="!!appearanceProgressBarValue ? appearanceProgressBarValue : 0">
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center mb-2">
                    <div class="rating-label">Installation</div>
                    <div class="progress flex-grow-1">
                        <div class="progress-bar installation" role="progressbar" aria-valuenow="40" aria-valuemin="0"
                            aria-valuemax="100"
                            [style.width.%]="!!installationProgressBarValue ? installationProgressBarValue : 0">
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center mb-2">
                    <div class="rating-label">Price / Value</div>
                    <div class="progress flex-grow-1">
                        <div class="progress-bar price-value" role="progressbar" aria-valuenow="40" aria-valuemin="0"
                            aria-valuemax="100" [style.width.%]="!!priceProgressBarValue ? priceProgressBarValue : 0">
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center mb-2">
                    <div class="rating-label">Quality</div>
                    <div class="progress flex-grow-1">
                        <div class="progress-bar quality" role="progressbar" aria-valuenow="40" aria-valuemin="0"
                            aria-valuemax="100"
                            [style.width.%]="!!qualityProgressBarValue ? qualityProgressBarValue : 0">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- col-2: average rating -->
        <div class="avg-rating text-end col-2 d-none d-lg-block">
            <span class="big">Average rating
                <small>{{ totalAverageOutOf5 | starpipe:'totalRating' }} of 5</small>
            </span>
            <div class="stars pe-md-5">
                <ng-container *ngIf="(totalAverageOutOf5 | starpipe:'fullStar') > 0;">
                    <ng-container *ngFor="let fullstar of (totalAverageOutOf5 | starpipe:'fullStar': true)">
                        <i class="fas fa-star star full fullStar "></i>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="(totalAverageOutOf5 | starpipe:'halfStar') > 0">
                    <ng-container *ngFor="let halfstar of (totalAverageOutOf5 | starpipe:'halfStar': true )">
                        <i class="fas fa-star-half-alt half-star "></i>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="(totalAverageOutOf5 | starpipe:'noStar') > 0">
                    <ng-container *ngFor="let noStar of (totalAverageOutOf5 | starpipe:'noStar': true)">
                        <i class="fas fa-star star empty grey-star "></i>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- Review Section -->
    <div class="review-info col-12" *ngFor="let review of visibleItems; let i= index">
        <!-- Review -->
        <div class="review-card">
            <div class="d-flex justify-content-between">
                <div class="review-wraper pb-3">
                    <div class="review-user d-flex align-items-center mb-1">
                        <img [src]="commonImagePath+'reviews-user_icon.webp'" class="me-2" alt="user"
                            loading="lazy">
                        <h4 class="mb-0">{{ review?.first_name }} {{ review?.last_name }} </h4>
                    </div>
                    <!-- Stars & Title in one line -->
                    <div class="d-flex align-items-center  flex-wrap">
                        <div class="review-stars">
                            <ng-container *ngIf="(individualTotalAverageOutOf5[i] | starpipe:'fullStar') > 0;">
                                <ng-container
                                    *ngFor="let fullstar of (individualTotalAverageOutOf5[i] | starpipe:'fullStar': true)">
                                    <i class="fa fa-star full-star" aria-hidden="true"></i>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="(individualTotalAverageOutOf5[i] | starpipe:'halfStar') > 0">
                                <ng-container
                                    *ngFor="let halfstar of (individualTotalAverageOutOf5[i] | starpipe:'halfStar': true )">
                                    <i class="fa fa-star-half-alt half-star" aria-hidden="true"></i>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="(individualTotalAverageOutOf5[i] | starpipe:'noStar') > 0">
                                <ng-container
                                    *ngFor="let noStar of (individualTotalAverageOutOf5[i] | starpipe:'noStar': true)">
                                    <i class="fa fa-star no-star" aria-hidden="true"></i>
                                </ng-container>
                            </ng-container>
                        </div>
                        <p class="review-title mb-0 pt-1 ps-2"><strong>{{ review?.title }}</strong></p>
                    </div>
                    <!-- Only show if date is valid -->
                    <p class="review-text mb-0" *ngIf="review?.add_dt && review?.add_dt !== '0000-00-00 00:00:00'">
                        Reviewed in the United States on {{ review?.add_dt | date: 'MMMM d, y' }}
                    </p>
                    <!-- Optional fallback: show message if date missing -->
                    <p class="review-text mb-0" *ngIf="!review?.add_dt || review?.add_dt === '0000-00-00 00:00:00'">
                        Reviewed in the United States
                    </p>
                    <!-- Verified Purchase Badge -->
                    <span class="review-text pe-1">Color: Orange</span>
                    <ng-container *ngIf="review?.verified_purchase === 1">
                        I <span class="more-review ps-1">verified purchase</span>
                    </ng-container>
                </div>
            </div>
            <p class="mb-0 review-text" [innerHTML]="review?.comments"></p>
        </div>
    </div>
    <div>
        <a class="more-review pt-4 ps-4 ps-md-0" (click)="loadMoreReviews()" *ngIf="hasMoreItems">
            see more reviews >
        </a>
    </div>
    <div class="text-start d-block d-lg-none ps-3">
        <button class="btn btn-review my-4" (click)="openReviewItPopup()">REVIEW PRODUCT</button>
    </div>
</div>